import { HYDRATE } from 'next-redux-wrapper';

import { ActionTypeEnum } from 'redux/ActionTypeEnum';

const initialState = {
	storeItems: {},
	branchesList: {},
	similarStores: [],
	widgets: [],
	installment: {},
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case HYDRATE: {
			return { ...state, ...action.payload['stores'] };
		}

		case ActionTypeEnum.branch_success: {
			return {
				...state,
				branchesList: action.payload,
			};
		}

		case ActionTypeEnum.similar_suppliers_success: {
			return {
				...state,
				similarStores: action.payload,
			};
		}

		case ActionTypeEnum.supplier_info_success: {
			const logoSquare = action.payload.ImageList.find((img) => img.SupplierImageTypeID === 1) || {};
			const logo = action.payload.ImageList.find((img) => img.SupplierImageTypeID === 2) || {};
			const coverSquare = action.payload.ImageList.find((img) => img.SupplierImageTypeID === 3) || {};
			const cover = action.payload.ImageList.find((img) => img.SupplierImageTypeID === 4) || {};
			const coverWide = action.payload.ImageList.find((img) => img.SupplierImageTypeID === 5) || {};
			const sliders = action.payload.ImageList.filter((img) => img.SupplierImageTypeID === 10) || [];

			return {
				...state,
				storeItems: {
					...state.storeItems,
					...action.payload,
					ImageList: {
						sliders,
						coverSquare,
						logoSquare,
						logo,
						cover,
						coverWide,
					},
				},
			};
		}

		case ActionTypeEnum.widget_success: {
			const widgets = action.payload.find((p) => p.Title === 'Center')?.Widgets || [];

			return {
				...state,
				widgets,
			};
		}

		case ActionTypeEnum.installment_success: {
			return {
				...state,
				installment: action.payload,
			};
		}

		default:
			return state;
	}
};

export { reducer as stores };
export * from './selectors';
